import React from 'react'
import styles from './styles.module.scss'
import clsx from 'clsx'

type FlagDesktopProps = {
  text: string
  className?: string
  fontColor: string
  backgroundColor: string
}

const FlagDesktop: React.FC<FlagDesktopProps> = ({
  text,
  className,
  fontColor,
  backgroundColor,
}) => {
  return (
    <div
      className={clsx(styles.flag, className)}
      style={{ backgroundColor: backgroundColor }}
    >
      <span style={{ color: fontColor }}>{text}</span>
    </div>
  )
}

export default FlagDesktop
